module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro-553990cce91337884cd3380cd31062a4.jpg";